import { useAppDispatch, useAppSelector } from '@verantos-dev/app-state-base';
import { FilterTypeLegacy } from '@verantos-dev/types-cohorts';

import {
  addActiveCohortBuilderItemFilter,
  deleteActiveCohortBuilderItemFilter,
} from '../cohortBuilderSlice';
import { selectActiveCohortBuilderItemConceptFilters } from '../selectors/cohortBuilderEditModalSelectors';

export const useConceptFilters = () => {
  const dispatch = useAppDispatch();
  const conceptFilters = useAppSelector(selectActiveCohortBuilderItemConceptFilters) ?? [];
  const onAddConceptFilterClick = () => {
    dispatch(addActiveCohortBuilderItemFilter(FilterTypeLegacy.CONCEPT));
  };

  const onDeleteConceptFilterClick = (id: string) => {
    dispatch(
      deleteActiveCohortBuilderItemFilter({
        filterId: id,
        filterType: FilterTypeLegacy.CONCEPT,
      })
    );
  };

  return {
    conceptFilters,
    onAddConceptFilterClick,
    // onEditConceptFilter,
    onDeleteConceptFilterClick,
  };
};
